import noun from 'plural-ru';
import { ReactNode } from 'react';
import { Skeleton } from '../components/Skeleton';
import { formatMoney } from '../utils/formatMoney';
import { usePriceDiff } from '../utils/usePriceDiff';

export const PriceAndButtons = ({
  price,
  basePrice,
  nights,
  children,
  isCompact,
  loading,
}: {
  price: number;
  basePrice?: number;
  nights: number;
  children: ReactNode;
  isCompact?: boolean;
  loading?: boolean;
}) => {
  const n = noun(nights, 'ночь', 'ночи', 'ночей');

  const { priceDiff, sign } = usePriceDiff(price, basePrice);

  return (
    <div className="mt-4 flex-1 items-center justify-end xl:mt-8 xl:flex">
      <div className={`flex ${isCompact && 'custom-compact-price'} ${priceDiff && 'mt-4 xl:mt-0'}`}>
        <Skeleton loading={loading} className="mb-3 h-[52px] w-2/3 xl:mb-0">
          <p
            className={`mb-3 inline-flex items-center text-[28px] font-light text-neutral-900 xl:mb-0 xl:flex-row xl:items-end xl:text-[32px] `}
          >
            <span className="relative mr-4 flex flex-col leading-8 xl:mr-3">
              <PriceDiff priceDiff={priceDiff} sign={sign} />
              от {formatMoney(price)} &#8381;
            </span>
            <span className="text-[16px] font-light leading-5 text-neutral-70  xl:text-[18px]">
              / за {nights} {n}
            </span>
          </p>
        </Skeleton>
      </div>
      {children}
    </div>
  );
};

const PriceDiff = ({ priceDiff, sign }: { priceDiff: number | null; sign: string }) => {
  if (!priceDiff || !sign) {
    return null;
  }

  const priceDiffClassName = priceDiff && priceDiff > 0 ? 'text-critical-100' : 'text-neutral-200';

  return (
    <span className={`custom-price-diff ${priceDiffClassName}`}>
      {sign} {formatMoney(Math.abs(priceDiff))} &#8381;
    </span>
  );
};
